<template>
  <form class="main-modal main-modal_w700" @submit.prevent="save" v-if="show">
    <div class="main-modal__title">
      <p v-text="modalTitle"></p>
    </div>

    <div
      :data-error="$t('errors.required')"
      :class="{ 'error-input': errors.has('first_name') }"
      class="main-form__box"
    >
      <label class="main-form__label" for v-text="$t('forms.name')"></label>
      <input
        v-validate="'required'"
        data-vv-as="first_name"
        name="first_name"
        class="main-form__input"
        type="text"
        v-model="administrator.first_name"
      />
    </div>

    <div
      :data-error="$t('errors.required')"
      :class="{ 'error-input': errors.has('last_name') }"
      class="main-form__box"
    >
      <label class="main-form__label" for v-text="$t('forms.surname')"></label>
      <input
        v-validate="'required'"
        data-vv-as="last_name"
        name="last_name"
        class="main-form__input"
        type="text"
        v-model="administrator.last_name"
      />
    </div>

    <div
      :data-error="$t('errors.required')"
      :class="{ 'error-input': errors.has('email') }"
      class="main-form__box"
    >
      <label class="main-form__label" for>Email</label>
      <input
        v-validate="'required'"
        data-vv-as="email"
        name="email"
        class="main-form__input"
        type="text"
        autocomplete="new-password"
        v-model="administrator.email"
      />
    </div>

    <div
      :data-error="$t('errors.phone')"
      :class="{ 'error-input': errors.has('phone') }"
      class="main-form__box"
    >
      <label class="main-form__label" for v-text="$t('forms.phone')"></label>
      <vue-tel-input
        v-model="administrator.phone"
        @validate="checkValue"
        :placeholder="$t('forms.phone')"
        :inputOptions="{ showDialCode: true }"
        mode="international"
        class="main-vue-tel-input"
        :defaultCountry="defaultCountry"
      ></vue-tel-input>
    </div>

    <div class="main-form__box" v-if="list">
      <label class="main-form__label" for v-text="'Niederlassung'"></label>

      <multiselect
        v-model="offices"
        :options="list"
        :multiple="true"
        label="address"
        track-by="address"
        :placeholder="'Offices'"
      />
    </div>

    <div class="main-form__box">
      <label class="main-form__label" for
        >{{ $t("forms.password") }} (e.g. Qwerty123)</label
      >
      <!-- <el-input
        :placeholder="`${$t('forms.passEnter')} (e.g. Qwerty123)`"
        v-model="administrator.password"
        show-password
        autocomplete="new-password"
        class="password-input password-input_h30 password-input_mb10"
      ></el-input>-->
      <input
        :placeholder="`${$t('forms.passEnter')} (e.g. Qwerty123)`"
        v-model="administrator.password"
        autocomplete="new-password"
        class="main-form__input"
        type="text"
      />
    </div>

    <div
      :data-error="$t('errors.required')"
      :class="{ 'error-input': errors.has('role') }"
      class="main-form__box mb16"
    >
      <Select2
        v-validate="'required'"
        data-vv-as="role"
        name="role"
        v-model="administrator.role"
        :settings="{ placeholder: 'Role' }"
        :options="roles"
        class="select2-container_w100"
      />
    </div>

    <div v-if="canAddPartner">
      <Select2
        v-model="administrator.partner_id"
        :options="mutatedPartners"
        class="main-form__box select select2-container_w100"
        name="partners"
        :settings="{
          placeholder: $t('navigation.partners'),
        }"
        @change="clearPartner"
      />
    </div>

    <div class="main-form__buttons main-form__buttons_center">
      <span
        @click="cancel"
        class="main-button main-button_cancel"
        v-text="$t('global.cancel')"
      ></span>
      <button
        class="main-button main-button_success"
        :class="{
          disabled: !isValid,
        }"
        :disabled="!isValid"
        v-text="buttonText"
      ></button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { checkEmail } from '@/utils/checkEmail'

export default {
    computed: {
        ...mapGetters({
            administrator: 'administrators/administratorGetters',
            isUpdate: 'administrators/isUpdateGetters',
            partners: 'partners/partnersGetters',
            show: 'administrators/showGetters',
            appeal: 'appealGetters',
            list: 'offices/list',
        }),
        isValid() {
            if (
                this.administrator.email === ''
        || this.administrator.email === null
        || !checkEmail(this.administrator.email)
            ) {
                return false
            }

            if (
                this.administrator.first_name === ''
        || this.administrator.first_name === null
            ) {
                return false
            }

            if (
                this.administrator.last_name === ''
        || this.administrator.last_name === null
            ) {
                return false
            }

            if (!this.isValidPhone) {
                return false
            }

            if (
                (this.administrator.password === ''
          || this.administrator.password === null)
        && !this.isUpdate
            ) {
                return false
            }

            if (this.administrator.password !== null && this.administrator.password !== undefined) {
                if (this.administrator.password.length <= 7) {
                    return false
                }
            }

            return !(this.isPartner && this.administrator.partner_id === null)
        },
        isPartner() {
            return this.administrator.role === 'partner-admin'
        },
        canAddPartner() {
            return (
                this.administrator !== null
        && this.isPartner !== false
        && this.mutatedPartners !== null
            )
        },
        buttonText() {
            return this.isUpdate === true
                ? this.$t('global.edit')
                : this.$t('forms.create')
        },
        modalTitle() {
            return this.isUpdate === true
                ? this.$t('administrators.update')
                : this.$t('administrators.add')
        },
    },
    watch: {
        show: 'clearModal',
    },
    data() {
        return {
            mutatedPartners: null,
            load: false,
            isValidPhone: false,
            roles: [
                {
                    text: this.$t('roles.superadmin'),
                    id: 'super-admin',
                },
                {
                    text: this.$t('roles.technicaladmin'),
                    id: 'technical-admin',
                },
                {
                    text: this.$t('roles.advancedadmin'),
                    id: 'advanced-admin',
                },
                {
                    text: this.$t('roles.normaladmin'),
                    id: 'normal-admin',
                },
                // {
                //     text: this.$t('roles.partneradmin'),
                //     id: 'partner-admin'
                // }
            ],
            defaultCountry: this.$config.behavior === 'hilfy' ? 'at' : 'de',
            offices: null,
        }
    },
    methods: {
        ...mapMutations({
            cancel: 'administrators/toggleModal',
        }),
        ...mapActions({
            create: 'administrators/create',
            update: 'administrators/update',
            fetch: 'partners/fetch',
            fetchOffices: 'offices/fetch',
        }),
        save() {
            this.$validator.validate().then((valid) => {
                if (!valid) return

                if (this.administrator.partner_id === null) {
                    delete this.administrator.partner_id
                }

                this.administrator.offices = this.offices.map((e) => e.id)

                this.isUpdate ? this.update(this.administrator.id) : this.create()
            })
        },
        clearPartner(e) {
            if (e !== 'all') {
                return
            }

            this.administrator.partner_id = null
        },
        preparePartners() {
            if (this.partners !== null) {
                this.mutatedPartners = this.partners.reduce((accum, item) => {
                    const data = {
                        id: item.id,
                        text: item.name,
                    }
                    accum.push(data)
                    return accum
                }, [])

                if (this.mutatedPartners[0] === null) {
                    return
                }

                if (this.mutatedPartners[0].id === 'all') {
                    return
                }

                this.mutatedPartners.unshift({
                    id: 'all',
                    text: 'Choose option',
                })
            }
        },
        checkValue(v) {
            this.isValidPhone = v.valid && v.type === 'mobile'
        },
        setIsLoad() {
            this.load = true
        },
        clearModal(v) {
            if (v) return

            this.$validator.reset()
            this.load = false
        },
    },
    async mounted() {
        await this.fetch({})
        await this.fetchOffices()

        this.offices = this.administrator.offices
    },
}
</script>

<style lang="scss">
  .main-modal {
    .multiselect--above .multiselect__content-wrapper {
      position: relative;
      bottom: 0;
    }
  }
</style>
